import { Stack, Typography } from '@mui/material';
import { type BackupSchedule } from '@repo/api-gw-sdk';

import type { StepProps } from '@/components/wizard/StepProps';

import type { BackupPolicyEditState } from './BackupPolicyCreationFlow';
import { BackupPolicySchedule, isValidSchedule } from './BackupPolicySchedule';
import { BackupPolicySettingsStepContainer } from './backupPolicySettingsStepContainer';
import { BackupPolicySupportedDisclaimer } from './customPolicySupportedDisclaimer';

export const BackupPolicySettingsNativePitr = (
  props: StepProps<BackupPolicyEditState>
) => {
  const updateSchedule = (schedule: BackupSchedule) => {
    const schedules =
      props.wizardState.schedules?.map((s) =>
        s.id === schedule.id ? schedule : s
      ) ?? [];

    props.setWizardState({ ...props.wizardState, schedules });
  };

  const schedule = props.wizardState.schedules?.[0];

  if (!schedule) {
    return null;
  }

  const canGoNext = () => {
    if (!props.wizardState.schedules?.length) {
      return false;
    }

    if (!isValidSchedule(schedule, props.wizardState.policyType)) {
      return false;
    }

    return true;
  };

  return (
    <BackupPolicySettingsStepContainer {...props} canGoNext={canGoNext}>
      <BackupPolicySupportedDisclaimer
        policyType={props.wizardState.policyType}
      />
      <Stack className='px-[min(100px,5vw)] pt-[min(60px,3vw)]'>
        <Stack
          direction='row'
          alignItems='center'
          justifyContent='space-between'
          sx={{ mb: '16px' }}
        >
          <Typography variant='body1'>Backup schedules</Typography>
        </Stack>
        <BackupPolicySchedule
          schedule={schedule}
          key={schedule.id}
          onUpdate={updateSchedule}
          mode={props.wizardState.mode}
          policyType={props.wizardState.policyType}
        />
      </Stack>
    </BackupPolicySettingsStepContainer>
  );
};
